<ng-container
  *ngFor="
    let notification of notifications$ | async;
    trackBy: trackBy;
    let i = index
  "
>
  <p-dialog
    [showHeader]="false"
    [visible]="!modalClosed[i]"
    (visible)="(!modalClosed[i])"
    [dismissableMask]="true"
    [draggable]="false"
    [modal]="true"
    [breakpoints]="{ '992px': '75vw', '640px': '90vw' }"
    [attr.data-e2e]="'form:alert:modal'"
  >
    <div
      class="message d-flex align-items-start mt-2 mb-2 mr-1 ml-1 mt-md-5 mb-md-5 mr-md-4 ml-md-4"
    >
      <svg
        class="d-none d-md-block"
        width="65"
        height="65"
        viewBox="0 0 36 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M35.742 27.2181L19.1213 0.67645C18.6059 -0.225451 17.3175 -0.225451 16.8021 0.67645L0.181356 27.2181C-0.334016 28.12 0.310199 29.2796 1.34094 29.2796H34.7113C35.742 29.1508 36.3862 27.9912 35.742 27.2181ZM19.1213 24.7701H16.6733V22.3221H19.1213V24.7701ZM19.1213 19.7452H16.6733V9.43778H19.1213V19.7452Z"
          fill="black"
        />
      </svg>

      <div class="ml-3">
        <p
          class="mb-3 mt-0"
          [innerHTML]="notification.message | pipeToBr : true"
        ></p>
        <ng-container
          *ngFor="let btn of notification.actions; trackBy: trackBy"
        >
          <button
            class="ds-button"
            [attr.data-e2e]="'btn-' + btn.code"
            [ngClass]="{ primary: btn.primary, secondary: btn.secondary }"
            (click)="executeAction(btn, i)"
            >{{ btn.label }}
          </button>
        </ng-container>
      </div>
    </div>
  </p-dialog>
</ng-container>
